// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1UbAX","emails":"CreateEditClinics_emails__3m4Vj","emailTagLabel":"CreateEditClinics_emailTagLabel__2Z-4O"};